module.exports = __webpack_public_path__ + "img/digi-crush-3.8923c59d.png";